import {
  DateTimeField,
  NumberField,
  RelationshipFieldMany,
  StringField,
  LongTextField,
} from "../plugins/Cruxtify/field-types";
import {
  DateTimeProperty,
  NumberProperty,
  RelationshipPropertyMany,
  StringProperty,
} from "../plugins/Cruxtify/property-types";
import {
  UserPermission,
  UserPermissions,
  UserRole,
} from "../plugins/Cruxtify/UserPermission";
import { ApcCrudModel } from "./ApcCrudModel";

export class ConfigurableSlotType extends ApcCrudModel {
  public static icon = "mdi-shape-outline";
  protected static _typeLabel = "Configurable Slot Type";
  protected static asProperty = "configurable_slot_type";
  public static api = {
    path: "configurable-slot-types",
  };

  protected static routeBase = "configurable-slot-types";

  protected static userPermissions = new UserPermissions(
    {
      [UserRole.SuperAdmin]: UserPermission.Edit,
      [UserRole.LoggedIn]: UserPermission.Read,
    },
    UserPermission.New
  );

  protected static propertyDefinitions = [
    {
      type: NumberProperty,
      opts: {
        name: "id",
        label: "ID",
        userPermissions: UserPermission.Hidden,
      },
    },
    {
      type: DateTimeProperty,
      opts: {
        name: "created_at",
        label: "Created At",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
    {
      type: DateTimeProperty,
      opts: {
        name: "updated_at",
        label: "Updated At",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
    {
      type: DateTimeProperty,
      opts: {
        name: "deleted_at",
        label: "deleted At",
        userPermissions: UserPermission.Hidden,
        computed: true,
      },
    },
    {
      type: StringProperty,
      opts: {
        name: "name",
        label: "Name",
        sortable: true,
        rules: ["required"],
      },
    },
    {
      type: StringProperty,
      opts: {
        name: "code",
        label: "Code",
        sortable: true,
        rules: ["required"],
      },
    },
    {
      type: StringProperty,
      opts: {
        name: "description",
        label: "Description",
      },
    },
    {
      type: RelationshipPropertyMany,
      opts: {
        name: "configurable_slots",
        label: "Configurable Slots",
        relatedModel: "ConfigurableSlot",
        foreignProperty: "configurable_slot_type",
      },
    },
    {
      type: RelationshipPropertyMany,
      opts: {
        name: "default_for_options",
        label: "Default For Options",
        relatedModel: "Option",
        foreignProperty: "configurable_slot_type",
      },
    },
  ];

  protected static fieldDefinitions = [
    { type: NumberField, opts: { property: "id" } },
    { type: DateTimeField, opts: { property: "created_at" } },
    { type: DateTimeField, opts: { property: "updated_at" } },
    { type: StringField, opts: { property: "name", isPrimaryLabelField: 1 } },
    { type: StringField, opts: { property: "code" } },
    { type: LongTextField, opts: { property: "description" } },
    {
      type: RelationshipFieldMany,
      opts: {
        property: "configurable_slots",
        viewComponentName: "form-relationship-field-many-table",
      },
    },
    {
      type: RelationshipFieldMany,
      opts: {
        property: "default_for_options",
        viewComponentName: "form-relationship-field-many-table",
      },
    },
  ];

  protected static collectionLayoutDefinitions = [
    {
      id: "table",
      columnFields: ["name", "code", "description"],
      enableSearch: true,
      enableDynamicFilters: true,
      useModal: true,
      dynamicFilterOptions: {
        filterFields: ["name", "code", "description"],
      },
      defaultSort: [
        {
          field: "name",
          order: "asc",
        },
      ],
    },
  ];

  protected static modelLayoutDefinitions = [
    {
      type: "FieldSetGridLayout",
      opts: {
        id: "slotTypeDetails",
        fieldSets: [
          {
            id: "main",
            fields: ["name", "code", "description"],
          },
          {
            id: "configurable_slots",
            fields: ["configurable_slots"],
          },
          {
            id: "default_for_options",
            fields: ["default_for_options"],
          },
          {
            id: "meta",
            fields: ["created_at", "updated_at", "id"],
          },
        ],
      },
    },
  ];
}
